import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BirthdaySection } from './components/BirthdaySection';
import { BusinessSection } from './components/BusinessSection';
import { MegaKitSection } from './components/MegaKitSection';
import { EmotionalSection } from './components/EmotionalSection';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <BirthdaySection data-id="element-2" />
      <BusinessSection data-id="element-3" />
      <MegaKitSection data-id="element-4" />
      <EmotionalSection data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FinalCTA data-id="element-9" />
    </div>;
}